var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454",
    transform: "translate(-1192.5 -285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 285)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(1205.623 244.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5428",
    "data-name": "Group 5428",
    transform: "translate(0 62.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5427",
    "data-name": "Group 5427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67640",
    "data-name": "Path 67640",
    d: "M12.564,154.015a1.35,1.35,0,0,1-1.4,0L0,147.2v9.059a3.507,3.507,0,0,0,3.506,3.506H20.248a3.507,3.507,0,0,0,3.506-3.506V147.2Z",
    transform: "translate(0 -147.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5430",
    "data-name": "Group 5430",
    transform: "translate(0.112 57.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5429",
    "data-name": "Group 5429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67641",
    "data-name": "Path 67641",
    d: "M22.184,57.088H5.441a3.485,3.485,0,0,0-3.393,2.748l11.779,7.179,11.751-7.179A3.485,3.485,0,0,0,22.184,57.088Z",
    transform: "translate(-2.048 -57.088)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7c2f59374e62b9369b2d2780d7f0fcab.svg";
export { ForwardRef as ReactComponent };